import { isAuthenticatedUser } from 'js/lib/user';

import { showNonSurveyNonPathwaysOnboarding } from 'bundles/onboarding-common/utils/experimentUtils';

const ROLE_SELECT_QUESTION_IDS = {
  roleSelect: 'role-select',
  roleSelectAdvancer: 'role-select-advancer',
} as const;

const QUESTION_IDS = {
  learningGoal: 'learning-goal',
  jobTitle: 'job-title',
  educationLevel: 'education-level',
  ...ROLE_SELECT_QUESTION_IDS,
  skillSelectAdvancer: 'skill-select-advancer',
  degreeInterest: 'degree-interest',
  interestedCareer: 'interested-career',
} as const;

const QUESTION_PATH_IDS = {
  default: 'default',
  learningGoalAdvancer: 'learningGoalAdvancer',
} as const;

const getQuestionPaths = () => {
  if (showNonSurveyNonPathwaysOnboarding()) {
    return {
      [QUESTION_PATH_IDS.default]: [
        QUESTION_IDS.learningGoal,
        QUESTION_IDS.interestedCareer,
        QUESTION_IDS.jobTitle,
        QUESTION_IDS.educationLevel,
        QUESTION_IDS.degreeInterest,
      ],
      [QUESTION_PATH_IDS.learningGoalAdvancer]: [
        QUESTION_IDS.learningGoal,
        QUESTION_IDS.jobTitle,
        QUESTION_IDS.educationLevel,
        QUESTION_IDS.interestedCareer,
        QUESTION_IDS.degreeInterest,
      ],
    };
  }

  return isAuthenticatedUser()
    ? {
        [QUESTION_PATH_IDS.default]: [
          QUESTION_IDS.learningGoal,
          QUESTION_IDS.roleSelect,
          QUESTION_IDS.jobTitle,
          QUESTION_IDS.educationLevel,
        ],
        [QUESTION_PATH_IDS.learningGoalAdvancer]: [
          QUESTION_IDS.learningGoal,
          QUESTION_IDS.roleSelectAdvancer,
          QUESTION_IDS.skillSelectAdvancer,
          QUESTION_IDS.educationLevel,
        ],
      }
    : {
        [QUESTION_PATH_IDS.default]: [QUESTION_IDS.learningGoal, QUESTION_IDS.roleSelect],
        [QUESTION_PATH_IDS.learningGoalAdvancer]: [
          QUESTION_IDS.learningGoal,
          QUESTION_IDS.roleSelectAdvancer,
          QUESTION_IDS.skillSelectAdvancer,
        ],
      };
};

const getRequiredQuestionIds = () =>
  isAuthenticatedUser()
    ? [QUESTION_IDS.learningGoal]
    : [QUESTION_IDS.learningGoal, QUESTION_IDS.roleSelect, QUESTION_IDS.roleSelectAdvancer];

const CPLUS_UPSELL_SLUG = 'coursera-plus-upsell';
const REGISTRATION_UPSELL_SLUG = 'signup';
const INTRO_PAGE_SLUG = 'intro';

const PROFILESV1_NAPTIME_QUESTION_IDS = [QUESTION_IDS.jobTitle, QUESTION_IDS.educationLevel];

export type QUESTION_IDS_TYPE = (typeof QUESTION_IDS)[keyof typeof QUESTION_IDS];
export type QUESTION_PATH_IDS_TYPE = (typeof QUESTION_PATH_IDS)[keyof typeof QUESTION_PATH_IDS];

export {
  QUESTION_IDS,
  QUESTION_PATH_IDS,
  CPLUS_UPSELL_SLUG,
  REGISTRATION_UPSELL_SLUG,
  INTRO_PAGE_SLUG,
  ROLE_SELECT_QUESTION_IDS,
  PROFILESV1_NAPTIME_QUESTION_IDS,
  getQuestionPaths,
  getRequiredQuestionIds,
};
